import * as L from 'leaflet'
import 'leaflet-defaulticon-compatibility'
import 'leaflet-gesture-handling'

document.addEventListener('DOMContentLoaded', () => {
  const leafletMapWrapperElements = document.querySelectorAll('.leaflet-map-wrapper')
  if (leafletMapWrapperElements) {
    leafletMapWrapperElements.forEach((leafletMapWrapperEl) => {
      const center = leafletMapWrapperEl.getAttribute('data-leaflet-center')
      const marker = leafletMapWrapperEl.getAttribute('data-leaflet-marker')
      const zoom = leafletMapWrapperEl.getAttribute('data-leaflet-zoom')
      const tooltip = leafletMapWrapperEl.getAttribute('data-leaflet-tooltip')

      if ((center || marker) && zoom) {
        // initialize the map
        const centerCoords = center || marker
        const map = L.map(leafletMapWrapperEl, {
          gestureHandling: true,
          center: centerCoords.split(','),
          zoom,
          minZoom: 8,
          maxZoom: 18
        })

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map)

        // build marker and add tooltip if necessary
        const markerCoords = marker || center
        const leafletMarker = L.marker(markerCoords.split(',')).addTo(map)
        if (tooltip) {
          leafletMarker.bindPopup(JSON.parse(tooltip))
        }
      }
    })
  }
})
